export default __webpack_public_path__ + "static/media/filter_mobile.6e184a7c.svg";